module.exports = __webpack_public_path__ + "media/images/plans/wedding_reception/estimate_2-f8c4088316a315a2c7cb06aa55840aad.jpg";